// material-ui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project-imports
import icon from 'assets/images/icon.png';

// ==============================|| LOGO ||============================== //

// Vektra's brand asset is a square icon (no wordmark in the file), so we
// compose the lockup here: icon + "Vektra" text. Use the dedicated icon.png
// rather than logo.png because icon.png is built for small UI usage.

export default function LogoMain() {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <img src={icon} alt="Vektra" height={40} width={40} style={{ display: 'block', objectFit: 'contain' }} />
      <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: 0.5 }}>
        Vektra
      </Typography>
    </Stack>
  );
}
